module.exports = __webpack_public_path__ + "static/img/blog_sm_portrait.55a5a31.png";


//////////////////
// WEBPACK FOOTER
// ./src/art/blog_sm_portrait.png
// module id = K/2B
// module chunks = 1